import { SelectInput } from './SelectInput';
import { hoursOptions, minutesOptions } from '../../utils/date';

type TimePickerProps = {
  hour: number;
  minutes: number;
  onTimeChange: (_hour: number, _minutes: number) => void;
};

export function TimePicker({ hour, minutes, onTimeChange }: TimePickerProps) {
  const correctedMinutes = Math.round(minutes / 5) * 5;

  return (
    <div className="flex justify-center min-w-full space-x-1 mt-5">
      <div className="w-1/2">
        <SelectInput
          label="Heure"
          value={hour}
          options={hoursOptions}
          onChange={value => {
            onTimeChange(parseInt(value), minutes);
          }}
        />
      </div>
      <div className="w-1/2">
        <SelectInput
          label="Minutes"
          value={correctedMinutes}
          options={minutesOptions}
          onChange={value => {
            onTimeChange(hour, parseInt(value));
          }}
        />
      </div>
    </div>
  );
}
